import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as rsdActions from '../rsd/rsd.actions';
import * as cameraActions from './cameras.actions';
import { CameraWithMediaDto, VideoStream } from "../../../core/store/models/camera-with-media.model";

export const camerasFeatureKey = 'cameras';

export interface CamerasState {
    trafficStream?: string;
    trafficCameraImage?: string;
    videoStreams?: VideoStream[];
    cameraStreamUrl?: string;
    cameraImageUrl?: string;
    vmsCameraMedia?: { [key: string]: CameraWithMediaDto[] };
    liveViewToken?: string;
    ui: {
    };
}

export const initialCamerasState: CamerasState = {
    trafficStream: null,
    trafficCameraImage: null,
    videoStreams: [],
    cameraStreamUrl: null,
    cameraImageUrl: null,
    vmsCameraMedia: null,
    liveViewToken: null,
    ui: {
    }
};

export const reducer: ActionReducer<CamerasState, Action> = createReducer(
    initialCamerasState,

    on(rsdActions.setSelectedDocument, (state, action) => {
        return {
            ...state,
            trafficStream: null,
            trafficCameraImage: null,
            cameraStreamUrl: null,
            cameraImageUrl: null
        };
    }),
    on(cameraActions.loadTrafficStream, (state, action) => {
        return {
            ...state,
            trafficStream: action.streamUrl
        };
    }),
    on(cameraActions.loadTrafficCameraImage, (state, action) => {
        return {
            ...state,
            trafficCameraImage: action.imageUrl
        };
    }),
    on(cameraActions.showVideoWindow, (state, action) => {
        return {
            ...state,
            videoStreams: [...state.videoStreams, action.videoStream]
        };
    }),
    on(cameraActions.hideVideoWindow, (state, action) => {
        return {
            ...state,
            videoStreams: [...state.videoStreams.filter(videoStream => videoStream != action.videoStream)]
        };
    }),
    on(cameraActions.refreshVideoStreamComplete, (state, action) => {
        return {
            ...state,
            videoStreams: [
                ...state.videoStreams.map(videoStream => {
                    if (videoStream.documentUId == action.videoStream.documentUId) {
                        videoStream.imageUrl = action.videoStream.imageUrl;
                        videoStream.videoUrl = action.videoStream.videoUrl;
                    }
                    return videoStream;
                })
            ]
        };
    }),
    on(cameraActions.loadOpenEyeCameraStreamUrl, (state, action) => {
        return {
            ...state,
            cameraStreamUrl: action.cameraStreamUrl
        };
    }),
    on(cameraActions.loadOpenEyeCameraImageUrl, (state, action) => {
        return {
            ...state,
            cameraImageUrl: action.cameraImageUrl
        };
    }),
    on(cameraActions.loadVmsCameraMedia, (state, action) => {
        const vmsCameraMedia = { ...state.vmsCameraMedia };
        if (!vmsCameraMedia[action.integrationKey] || action.cameras?.length > 1) {
            vmsCameraMedia[action.integrationKey] = action.cameras;
        } else {
            vmsCameraMedia[action.integrationKey] = vmsCameraMedia[action.integrationKey]
                .filter(c => !!c && !action.cameras?.find(nc => nc.id === c.id))
                .concat(action.cameras);
        }
        return {
            ...state,
            vmsCameraMedia
        };
    }),
  on(cameraActions.loadVideoStreamUrl, (state, action) => {
    return {
      ...state,
      cameraStreamUrl: action.videoStreamUrl
    };
  }),
  on(cameraActions.loadLiveViewToken, (state, action) => {
    return {
      ...state,
      liveViewToken: action.liveViewToken
    };
  })
);

export const getCurrentTrafficStream = (state: CamerasState) => state?.trafficStream;

export const getTrafficImage = (state: CamerasState) => state?.trafficCameraImage;

export const getVideoStreams = (state: CamerasState) => state?.videoStreams;

export const getCameraStreamUrl = (state: CamerasState) => state?.cameraStreamUrl;

export const getCameraImageUrl = (state: CamerasState) => state?.cameraImageUrl;

export const getVmsCameraMediaData = (state: CamerasState) => state?.vmsCameraMedia;

export const getLvtToken = (state: CamerasState) => state?.liveViewToken;
